/**
 * Static SIM upsell choices aligned with Network Plan builder
 * (`plan-builder-primary-data-card`, `plan-summary-pay-section` / `monthOptions`).
 * Replace with API-driven options when integrated.
 */
export const SIM_CARD_UPSELL_PRIMARY_DATA_OPTIONS = [
  { value: "1gb", label: "1GB" },
  { value: "4gb", label: "4GB" },
  { value: "12gb", label: "12GB" },
  { value: "22gb", label: "22GB" },
  { value: "unlimited", label: "Unlimited" },
] as const;

export type SimCardUpsellPrimaryDataValue =
  (typeof SIM_CARD_UPSELL_PRIMARY_DATA_OPTIONS)[number]["value"];

/** Billing cadence labels — mirrors `NetworkPlan/constants` `monthOptions`. */
export const SIM_CARD_UPSELL_FREQUENCY_OPTIONS = [
  { value: "monthly", label: "1 Month" },
  { value: "threeMonths", label: "3 Months - Save 15%" },
  { value: "sixMonths", label: "6 Months - Save 25%" },
  { value: "twelveMonths", label: "12 Months - Save 35%" },
] as const;

export type SimCardUpsellFrequencyValue =
  (typeof SIM_CARD_UPSELL_FREQUENCY_OPTIONS)[number]["value"];

export function getSimCardUpsellPrimaryDataLabel(
  value: string,
): string {
  const row = SIM_CARD_UPSELL_PRIMARY_DATA_OPTIONS.find((o) => o.value === value);
  return row?.label.replace(/\s*\(Most Popular\)\s*$/i, "").trim() || value;
}

/** Short suffix for static marketing price row (e.g. $99 /3 mo). */
export function getSimCardUpsellFrequencyPriceSuffix(
  frequency: string,
): string {
  switch (frequency) {
    case "monthly":
      return "mo";
    case "threeMonths":
      return "3 mo";
    case "sixMonths":
      return "6 mo";
    case "twelveMonths":
      return "year";
    default:
      return "mo";
  }
}
